// `ViewerMode` belongs to the viewer itself, so it lives in `@shared/viewers/feature`
// — that also keeps that lib from depending back on this one. Re-exported here to
// keep it alongside the other viewer enums for consumers.
export { ViewerMode } from '@shared/viewers/feature';

export enum DrawingMode {
  center = 'center',
  boundingBox = 'boundingBox',
  sketch = 'sketch',
  lasso = 'lasso',
}

export enum ImageFilterType {
  CONTRAST = 'contrast',
  SATURATION = 'saturation',
  BRIGHTNESS = 'brightness',
  NEGATIVE = 'negative',
}

export interface ImageFilter {
  filter: ImageFilterType;
  value: number;
}

export enum ETabContext {
  AI = 'ai',
  ANALYST = 'analyst',
  FILTERS = 'filters',
  RULER = 'ruler',
}

export enum RulerType {
  NONE = 'none',
  LINE = 'line',
  CROSS = 'cross',
  CIRCLE = 'circle',
}

export enum CounterMode {
  counter = 'counter',
  percentage = 'percentage',
}
